// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgEmoji24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12C2 6.48 6.47 2 11.99 2ZM11.99 3.5C7.3008 3.5 3.5 7.30605 3.5 12C3.5 16.6939 7.3008 20.5 11.99 20.5C16.6903 20.5 20.5 16.6929 20.5 12C20.5 7.30711 16.6903 3.5 11.99 3.5ZM7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5ZM14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5ZM16.41 13.89C16.06 13.67 15.59 13.78 15.38 14.13C14.64 15.3 13.38 16 12 16C10.62 16 9.36 15.3 8.62 14.12C8.4 13.77 7.94 13.66 7.59 13.88C7.24 14.1 7.13 14.56 7.35 14.91C8.37 16.54 10.1 17.5 12 17.5C13.9 17.5 15.63 16.53 16.65 14.92C16.87 14.57 16.76 14.11 16.41 13.89Z"
				/>
			</Svg>
		);
	}
);
SvgEmoji24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgEmoji24;
